export const StoreState = {
    item:'item'
}

export const state = {
    [StoreState.item]:null
}
